import React, { useEffect, useState } from 'react';
import './LoadingBar.css';

const LoadingBar = ({ isLoading }) => {
    const [visible, setVisible] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        let interval;
        if (isLoading) {
            setVisible(true);
            setProgress(0);
            interval = setInterval(() => {
                setProgress((prev) => {
                    if (prev >= 90) {
                        clearInterval(interval);
                        return 90;
                    }
                    return prev + Math.random() * 10;
                });
            }, 200);
        } else {
            setProgress(100);
            const timeout = setTimeout(() => {
                setVisible(false);
                setProgress(0);
            }, 400);
            return () => clearTimeout(timeout);
        }
        return () => clearInterval(interval);
    }, [isLoading]);

    if (!visible) return null;

    return (
        <div className="loading-bar-container">
            <div
                className="loading-bar-fill"
                style={{ width: `${progress}%` }}
            >
                <div className="loading-bar-glow"></div>
            </div>
        </div>
    );
};

export default LoadingBar;
